import {
  Component,
  OnInit,
  Input,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { getCurrentShiftDate } from 'src/app/utils/utils';
import { DatePicker } from '@openng/optimus-ui/datepicker';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-shift-date-panel',
  templateUrl: './shift-date-panel.component.html',
  styleUrls: ['./shift-date-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePicker, FormsModule, TranslatePipe],
})
export class ShiftDatePanelComponent implements OnInit {
  maxDateValue = new Date();

  @Input() value!: Date;
  readonly isDisabled = input<boolean>(false);

  readonly dateChange = output<Date>();

  constructor() {}

  ngOnInit(): void {
    if (!this.value) {
      this.value = getCurrentShiftDate();
    }
  }

  onDateChange(value: Date) {
    this.dateChange.emit(value);
  }

  changeValue(newValue: Date) {
    this.value = newValue;
    this.dateChange.emit(this.value);
  }
}
